<template>
  <Modal
    :media-u-r-l="mediaURL"
    @click-close="onClickClose"
  >
    <slot>
      <h2 class="text-center">
        Thank You.
      </h2>
      <p class="text-center">
        Your $10 coupon has been applied!
      </p>
      <div>
        <button
          class="btn btn-primary btn-block w-100"
          @click="clickCTA"
        >
          Shop Now
        </button>
      </div>
    </slot>
  </Modal>
</template>

<style scoped>
  * >>> .modal-container {
    background: #0D2325;
    height: auto;
  }

  * >>> .modal-content-container {
    padding: 80px 0;
  }

  * >>> .modal-image-container {
    order: 3;
    min-height: 200px;
  }

  @media (max-width: 576px) {
    * >>> .modal-image-container {
      order: 1;
    }

    * >>> .modal-content-container {
      padding: 25px 0;
    }
  }

  h2, p, small {
    color: white;
  }

</style>

<script>
import Modal from './Modal.vue';
import mediaURL from '../../../../static/images/referral/as-referral-onsite.jpg';

export default {
  components: {
    Modal,
  },
  props: {
    onClickClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mediaURL,
    };
  },
  methods: {
    clickCTA() {
      window.vueAPI.closeModal();
    },
  },
};
</script>
